import { render } from "./TripRecordTitleComponent.vue?vue&type=template&id=57416477&scoped=true"
import script from "./TripRecordTitleComponent.vue?vue&type=script&lang=ts"
export * from "./TripRecordTitleComponent.vue?vue&type=script&lang=ts"

import "./TripRecordTitleComponent.vue?vue&type=style&index=0&id=57416477&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-57416477"

export default script